/**
 * Defines an error for when a something is wrong in the development area (not related to the code).
 * @memberof module:MCError
 * @author Declan Clark <dec@dclark.dev>
 * @example
 * throw new MCError.DevelopmentError('expected a non-empty array');
 */
class DevelopmentError extends Error {
  /**
   * Initialises an DevelopmentError.
   * @param {string} message  The error message.
   */
  constructor(message) {
    super(message);
    this.name = "DevelopmentError";
  }
}

export { DevelopmentError };
